import "../css/home.css"
import Hi from "../images/hi.webp";
import Typewriter from 'typewriter-effect';
import MidLogo from "../images/midLoGO.webp";
import Navigation from "./Navigation";
import Contact from "./Contact";
export default function Home(){
    return (
        <div style={{overflow:"hidden",width:"100%",height:"90%"}}>
          <div id="background"></div>
        <div id="home" >
            <Navigation />
            <div id="bar">
                <div ></div>
                <Typewriter
  options={{
    strings: ["NodeJs","ReactJs","MongoDB","ExpressJS"],
    autoStart: true,
    loop: true,
  }}
/>
            </div>
           <div id="mid">
           <img src={MidLogo} alt="LOGO" />
           </div>
         <div id="name">Tarakeswar<br />Mondal
        <br />
        <div id="welcome">
        <Typewriter
  options={{
    strings: [" Welcome to portfolio","See my projects","I can build project for you","at very affordable price"],
    autoStart: true,
    loop: true,
  }}
/>
           </div>
   
        </div>
        <img src={Hi} alt="Hello PNG"/>
       <Contact />
        </div>
      
        </div>
    );
}